import { useState, useEffect } from 'react';
import applause from '../assets/images/applause.svg';
import { MAX_TIMER } from './IncorrectAnswer';
import football from '../assets/images/football-resized.png';


function CorrectAnswer({ questionNum, totalQuestions, questionText, proceed }) {
  const [feedbackTimer, setFeedbackTimer] = useState(MAX_TIMER);

  useEffect(() => {
    const countAux = feedbackTimer > 0 && setInterval(() => setFeedbackTimer((lastTimer) => lastTimer - 1), 1000);

    if (feedbackTimer === 0) {
      clearInterval(countAux);
      proceed();
    }
    return () => clearInterval(countAux);
  }, [feedbackTimer, proceed]);

  return (
    <div className="d-flex flex-column z-index-2 h-75 w-95">

      <div className="gradient-rounded-border-green rect-scooped-corners mx-4 my-2 h-100 shadow">
        <div className="box w-100 h-100">
          <div className="top-shine"></div>
          <div className="corner nw"></div>
          <div className="corner ne"></div>
          <div className="corner sw"></div>
          <div className="corner se"></div>
          <div className="d-flex flex-column justify-content-between align-items-center h-100 bg-white box-content">
            <div className="d-flex justify-content-center align-items-center fw-semibold badge-status-correct mw-50 py-2 px-3 mt-3">
              <img src={applause} alt="Correcto" />
              <span className="text-white fw-bold ms-1">Correcto</span>
            </div>
            <div className="question-text question-text-correct text-center">{questionText}</div>
            <div className="question-num-container question-num-container-correct">
              <div>Pregunta</div>
              <div className="mb-1">
                <span className="question-current">{questionNum}</span>/<span>{totalQuestions}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div className="question-answer mt-2">
        <img src={football} alt="Balón" className="swipe-ball" />
      </div>
    </div>
  );
}

export default CorrectAnswer
